import { combineReducers } from 'redux';
import logTReducer from './logTReducer';

const rootReducer = combineReducers({
  logTReducer
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;